import {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getBrands} from '../core/_requests'
import {Brand} from '../core/_models'
import {BrandForm} from './BrandForm'
import {Columns} from './columns/_columns'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

/**
 * Toolbar buttons
 */
const buttons: Array<ButtonProps> = [{
  label: 'Add',
  className: 'btn btn-primary me-3',
  icon: {
    name: 'plus',
    className: 'fs-2'
  },
  openModal: 'add'
}]


/**
 * Modal wrapper to manage open modal
 */
const BrandModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  return (
    <>
      {itemForUpdate && action === 'edit' && (
        <Modal title={`Change ${(itemForUpdate as Brand).name} status`}>
          <BrandForm />
        </Modal>
      )}

      {itemForUpdate === null && action === 'add' && (
        <Modal title="Add brand">
          <BrandForm />
        </Modal>
      )}
    </>
  )
}

const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Brands list</PageTitle>
    <TableWrapper
      dataProvider={getBrands}
      cols={Columns}
      queryId="BRANDS_LIST"
      lookup={{placeholder: 'Search Brand'}}
      buttons={buttons}
      modals={BrandModalWrapper}
    />
  </>
)

export default ListWrapper
